// src/utils/eventNormalizer.js
export const normalizeEvents = (events) => {
  return events.map((e) => {
    const extendedProps = {
      ...e.extendedProps,

      // ✅ CRITICAL: pull event_type into extendedProps
      event_type: e.extendedProps?.event_type || e.event_type || "event",

      primary_technician:
        e.extendedProps?.primary_technician || e.technician_name || "-",

      additional_technicians:
        e.extendedProps?.additional_technicians &&
        e.extendedProps.additional_technicians !== "NaN"
          ? e.extendedProps.additional_technicians
          : e.additional_technician && e.additional_technician !== "NaN"
          ? e.additional_technician
          : "-",

      property:
        e.extendedProps?.property && e.extendedProps.property !== "NaN"
          ? e.extendedProps.property
          : e.property && e.property !== "NaN"
          ? e.property
          : "-",
    };

    return { ...e, extendedProps };
  });
};
